module.exports = __webpack_public_path__ + "img/en_large.ce9ffb0e.png";